type Props = {
  children: JSX.Element | string | number | (JSX.Element | string | number)[];
  className?: string;
};

export const CardTitle = ({ children, className }: Props) => (
  <h1 className={`text-primary text-sm font-bold uppercase pt-2 pb-5 ${className}`}>{children}</h1>
);
